import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ContextService } from '../services/context.service';
import { MsalHelperService } from '../services/msal-helper.service';
import { combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-mcp-announce',
    templateUrl: './mcp-announce.component.html',
    styleUrl: './mcp-announce.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class McpAnnounceComponent implements OnInit {

    mcpLink$ = combineLatest([
        this.contextService.entitlement$,
        this.msalHelperService.user$.pipe(startWith(this.msalHelperService.getUser()))
    ]).pipe(
        map(([entitlement, user]) => {
            const status = `${entitlement?.status || ''}`.toLowerCase();
            const email = user?.username ?? '';
            const isSubscriber = !!email && (status === 'active' || status === 'trialing');
            return isSubscriber
                ? `https://mcp.flowstudio.app/?bundle=${encodeURIComponent(email)}`
                : 'https://mcp.flowstudio.app';
        })
    );

    isPaid$ = this.mcpLink$.pipe(
        map(link => link.includes('?bundle='))
    );

    constructor(
      @Optional() public dialogRef: DialogRef,
      private contextService: ContextService,
      private msalHelperService: MsalHelperService
    ) {
    }

    ngOnInit() {
        this.contextService.load();
    }

}
